import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import { FieldError } from 'react-aria-components';

const errorMessage = "_error-message_f7oso_1";
const styles = {
	errorMessage: errorMessage
};

const ErrorMessage = (_a) => {
  var { children, isCompact } = _a, props = __rest(_a, ["children", "isCompact"]);
  return jsx(FieldError, Object.assign({}, props, { className: styles.errorMessage, "data-compact": isCompact, "data-zds": true, children }));
};

export { ErrorMessage };
//# sourceMappingURL=ErrorMessage.es.js.map
